import { render } from "./ConceptDetail.vue?vue&type=template&id=f741f498"
import script from "./ConceptDetail.vue?vue&type=script&lang=js"
export * from "./ConceptDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ThesauRex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__